export class RequestDescriptor {
    constructor(credentials) {
        this.credentials = credentials;
    }
}
;
export class Credentials {
}
;
//# sourceMappingURL=Authorizer.js.map